import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC, type ReactNode } from 'react'

type Props = ComponentPropsWithoutRef<'div'> & {
  icon?: ReactNode
  suffix?: ReactNode
}

export const PopoverListItem: FC<Props> = ({
  className,
  icon,
  suffix,
  children,
  ...props
}) => {
  return (
    <div
      {...props}
      className={clsx([
        'group flex cursor-pointer items-center gap-2.5 p-3 pl-6 text-[13px] leading-none hover:bg-[#fafafa]',
        className
      ])}
    >
      <div className="w-[12px] text-[12px] text-secondary group-hover:text-primary">
        {icon}
      </div>
      <div className="flex-1 text-black group-hover:text-primary">
        {children}
      </div>
      <div className="w-[12px] text-[12px] text-secondary group-hover:text-primary">
        {suffix}
      </div>
    </div>
  )
}
